import { gql } from '@apollo/client';
export const LOGIN = gql`
  mutation Login($email: String!, $password: String!, $provider: String) {
    login(email: $email, password: $password, provider: $provider) {
      __typename

      ... on LoginResponse {
        accessToken
        user {
          firstName
          lastName
        }
      }

      ... on LoginError {
        code
      }

      ... on UserNotActivated {
        email
      }
    }
  }
`;

export const LOGIN_SETTINGS = gql`
  query LoginSettings($email: String!) {
    loginSettings(email: $email) {
      provider
      authDomain
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($newPassword: String!, $newPasswordRepeated: String!, $oldPassword: String!) {
    changePassword(
      input: { newPassword: $newPassword, newPasswordRepeated: $newPasswordRepeated, oldPassword: $oldPassword }
    ) {
      __typename

      ... on ChangePasswordPayload {
        success
      }

      ... on ChangePasswordInvalidInputError {
        oldPasswordMessage
      }
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ForgottPassword($email: String!) {
    ForgotPasswordMagicLink(email: $email) {
      __typename
      ... on User {
        email
      }
      ... on UserNotActivated {
        email
      }
      ... on LoginError {
        code
      }
    }
  }
`;

export const RESEND_INVITATION = gql`
  mutation ResendInvitation($email: String!) {
    ReinviteToOrganization(input: { email: $email })
  }
`;
